<div class="ws-popup-header">
  <div>{{ 'payments.list.refundTitle' | translate }}</div>
  <div class="actions">
    <button (click)="closeClicked()" [disabled]="isProcessing" mat-icon-button type="button">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>

<div class="ws-popup-content">
  <div class="ws-popup-body refund-wrapper">
    <div class="processing-overlay" *ngIf="isProcessing">
      <app-loading></app-loading>
      <p class="processing-text">{{ 'refund_dialog.processing' | translate }}</p>
    </div>

    <p class="refund-info">{{ 'payments.list.refundDialogInfo' | translate }}</p>

    <div class="customer-row" *ngIf="data.customerName">
      <span class="customer-label">{{ 'payments.list.detailCustomerName' | translate }}</span>
      <span class="customer-value">{{ data.customerName }}</span>
    </div>

    <form [formGroup]="form" (ngSubmit)="confirmClicked()">
      <div class="form-container">
        <div class="field-wrapper">
          <label for="refundAmount">{{ 'payments.list.refundAmount' | translate }}</label>
          <div class="input-wrapper amount-input">
            <input
              id="refundAmount"
              formControlName="amount"
              type="number"
              step="0.01"
              min="0.01"
              matInput
              [class.input-error]="form.get('amount')?.invalid && form.get('amount')?.touched" />
            <span class="currency-suffix">{{ currencySymbol }}</span>
          </div>
          <span class="field-hint">
            {{ 'payments.list.refundMaxAmount' | translate }}: {{ maxAmountLabel }}
          </span>
          <span class="field-error" *ngIf="form.get('amount')?.hasError('max')">
            {{ 'payments.list.refundInvalidAmount' | translate }}
          </span>
        </div>

        <div class="field-wrapper">
          <label>{{ 'payments.list.refundReason' | translate }}</label>
          <div class="input-wrapper">
            <ws-selector
              [options]="reasonOptions"
              [selected]="form.get('reason')?.value"
              (selectedChange)="onReasonChange($event)"
              [formatter]="optionNameFormatter"
              [placeholder]="'Select option' | translate">
            </ws-selector>
          </div>
        </div>

        <div class="field-wrapper field-wrapper--full">
          <label for="refundNotes">{{ 'payments.list.refundNotes' | translate }}</label>
          <div class="input-wrapper">
            <textarea
              id="refundNotes"
              formControlName="notes"
              rows="3"
              [placeholder]="'payments.list.refundNotesPlaceholder' | translate"></textarea>
          </div>
        </div>
      </div>
    </form>
  </div>

  <div class="ws-popup-footer">
    <ws-button
      [callToActionType]="'danger'"
      type="button"
      [disabled]="isProcessing"
      (click)="cancelClicked()">
      {{ 'payments.list.refundCancel' | translate }}
    </ws-button>
    <ws-button
      [callToActionType]="'primary'"
      type="button"
      [disabled]="isProcessing"
      (click)="confirmClicked()">
      {{ 'payments.list.refundConfirm' | translate }}
    </ws-button>
  </div>
</div>
